module.exports = __webpack_public_path__ + "img/switch-1.bb333ebe.webp";